"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var constants_1 = require("./utils/constants");
var utils_1 = require("./utils/utils");
var debounce_1 = require("debounce");
/*
 * Компонент предназначен для автоматического сохранения состояния таблицы.
 * Состояние сохраняется в отдельный пресет, когда оно изменилось без смены пресета;
 * pageSize и pageIndex не учитываются.
 * */
function TTableAutoSavePreset(props) {
    var registryCode = props.registryCode, presets = props.presets, currentPreset = props.currentPreset, tableState = props.tableState, savePreset = props.savePreset, onSavePreset = props.onSavePreset, visibleColumns = props.visibleColumns;
    var autoSavedPresetId = react_1.useMemo(function () { var _a; return (_a = presets.find(function (p) { return p.autoSaved; })) === null || _a === void 0 ? void 0 : _a.id; }, [presets]);
    var intl = react_intl_1.useIntl();
    var lastStateMessage = intl.formatMessage({ id: 'ttable.lastState', defaultMessage: 'Последнее состояние' });
    // параметры текущего состояния таблицы
    var visibleColumnIds = react_1.useMemo(function () { return visibleColumns.map(function (c) { return c.id; }).sort(); }, [visibleColumns]);
    var sortBy = react_1.useMemo(function () { return tableState.sortBy; }, [tableState]);
    var filters = react_1.useMemo(function () { return tableState.filters.sort(utils_1.compareByIdAlphabet); }, [tableState]);
    var columnOrder = react_1.useMemo(function () { return tableState.columnOrder; }, [tableState]);
    // параметры состояния таблицы из выбранного пресета
    var currentPresetTableState = react_1.useMemo(function () { return currentPreset.data; }, [currentPreset]);
    var currentPresetVisibleColumnIds = react_1.useMemo(function () { var _a; return (_a = currentPresetTableState.visibleColumns) === null || _a === void 0 ? void 0 : _a.sort(); }, [
        currentPresetTableState,
    ]);
    var currentPresetSortBy = react_1.useMemo(function () { return currentPresetTableState.sortBy; }, [currentPresetTableState]);
    var currentPresetFilters = react_1.useMemo(function () { return currentPresetTableState.filters.sort(utils_1.compareByIdAlphabet); }, [
        currentPresetTableState,
    ]);
    var currentPresetColumnOrder = react_1.useMemo(function () { return currentPresetTableState.columnOrder; }, [currentPresetTableState]);
    // результаты сравнения параметров для определения нужно ли сохранять последнее состояние или нет
    var _a = react_1.useState(false), visibleColumnsIsChanged = _a[0], setVisibleColumnsIsChanged = _a[1];
    react_1.useEffect(function () {
        setVisibleColumnsIsChanged(!lodash_isequal_1.default(visibleColumnIds, currentPresetVisibleColumnIds));
    }, [visibleColumnIds, currentPresetVisibleColumnIds]);
    var _b = react_1.useState(false), sortByIsChanged = _b[0], setSortByIsChanged = _b[1];
    react_1.useEffect(function () {
        setSortByIsChanged(!lodash_isequal_1.default(sortBy, currentPresetSortBy));
    }, [sortBy, currentPresetSortBy]);
    var _c = react_1.useState(false), filtersIsChanged = _c[0], setFiltersIsChanged = _c[1];
    react_1.useEffect(function () {
        setFiltersIsChanged(!lodash_isequal_1.default(filters, currentPresetFilters));
    }, [filters, currentPresetFilters]);
    var _d = react_1.useState(false), columnOrderIsChanged = _d[0], setColumnOrderIsChanged = _d[1];
    react_1.useEffect(function () {
        setColumnOrderIsChanged(!lodash_isequal_1.default(columnOrder, currentPresetColumnOrder));
    }, [columnOrder, currentPresetColumnOrder]);
    var tableStateIsChanged = react_1.useMemo(function () { return visibleColumnsIsChanged || sortByIsChanged || filtersIsChanged || columnOrderIsChanged; }, [visibleColumnsIsChanged, sortByIsChanged, filtersIsChanged, columnOrderIsChanged]);
    // информация о том сменился ли пресет
    var currentPresetId = currentPreset.id;
    var _e = react_1.useState(false), presetIsChanged = _e[0], setPresetIsChanged = _e[1];
    react_1.useEffect(function () {
        setPresetIsChanged(true);
    }, [currentPresetId]);
    var resetChangedFlags = react_1.useCallback(function () {
        setVisibleColumnsIsChanged(false);
        setFiltersIsChanged(false);
        setSortByIsChanged(false);
        setColumnOrderIsChanged(false);
        setPresetIsChanged(false);
    }, [
        setVisibleColumnsIsChanged,
        setFiltersIsChanged,
        setSortByIsChanged,
        setColumnOrderIsChanged,
        setPresetIsChanged,
    ]);
    react_1.useEffect(debounce_1.debounce(function () {
        if (!presetIsChanged && tableStateIsChanged) {
            var presetData = {
                sortBy: sortBy,
                filters: filters,
                columnOrder: columnOrder,
                hiddenColumns: [],
                visibleColumns: visibleColumnIds,
                pageIndex: 0,
                pageSize: constants_1.DEFAULT_PAGE_SIZE,
            };
            var preset = {
                id: autoSavedPresetId,
                title: lastStateMessage,
                autoSaved: true,
                data: presetData,
                registryCode: registryCode,
                shared: false,
                default: false,
                sharedRules: [],
            };
            savePreset(preset).then(function (preset) {
                onSavePreset(preset);
                resetChangedFlags();
            });
        }
        if (presetIsChanged) {
            resetChangedFlags();
        }
    }, 500), [presetIsChanged, visibleColumnsIsChanged, sortByIsChanged, filtersIsChanged, columnOrderIsChanged]);
    return null;
}
exports.default = TTableAutoSavePreset;
